'use client';
import useWishlist from 'grandus-lib/hooks/v2/useWishlist';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import Card from "@/app/components/product/card/ProductCard";
// import ProductsLoading from "@/components/category/products/ProductsLoading";
import EmptyComponent from "@/components/_other/emptyComponent/EmptyComponent";
import upperFirst from "lodash/upperFirst";
import {useTranslation} from "@/app/i18n/client";

const Listing = () => {
  const { products, isLoading: isLoadingWishlist } = useWishlist();
  const { t } = useTranslation();

  if (isEmpty(products) && !isLoadingWishlist) {
    return (
      <EmptyComponent title={upperFirst(t('wishlist.empty.title'))} normalText={t('wishlist.empty.subtitle')} />
    );
  }

  // if (isLoadingWishlist) {
  //   return <ProductsLoading />;
  // }

  return (
    <div
      id="products-list"
      className={'grid grid-cols-2 md:grid-cols-3 py-4 gap-4 md:gap-6'}
    >
          {map(products, product => <Card product={product} key={`wishlist-product-${product?.id}`} imageField={'small_image'} /> )}
      </div>
  );
};

export default Listing;
